import { GTM_EVENTS_DATA as WISHLISTS_TRACKING_DATA } from '@/domains/proB2BServices/Wishlists/gtmEvents';

export const GTM_EVENTS_DATA: {
  [index: string]: Record<string, string>;
} = {
  CREATE_LIST: WISHLISTS_TRACKING_DATA.CREATE,
  ADD_TO_WISHLIST: {
    event: 'interaction_list add to wishlist',
    amp_event_name: 'Click on add to wishlist',
    e_category: 'navigation',
    e_action: 'Click on add to wishlist',
    interaction_hit: 'False',
  },
};
